// 引用的客服模式下面的代码
/**
 * Author：brand
 * Creation Time：2019-10-08 11:51
 * Email：brandhuang@qq.com
 */

import ax from '../../axios'

/**
 * 创建工单
 * @param params
 */
export function createWorkorderAPI (params) {
  return ax({
    url: '/wlapi/tickets/createTicket',
    method: 'POST',
    params
  })
}
/**
 * 获取所有人工客服
 * @param params
 */
export function getAllServiceAPI (params) {
  return ax({
    url: '/wlapi/tickets/allAgentCs',
    method: 'POST',
    params
  })
}
/**
 * 获取工单列表（根据不同参数筛选）
 * @param params
 */
export function getWorkorderListAPI (params) {
  return ax({
    url: '/wlapi/tickets/search',
    method: 'POST',
    params
  })
}
/**
 * 获取工单详情
 * @param params
 */
export function getWorkorderDetailAPI (params) {
  return ax({
    url: '/wlapi/tickets/ticketDetail',
    method: 'POST',
    params
  })
}
/**
 * 重新打开
 * @param params
 */
export function reopenWorkorderAPI (params) {
  return ax({
    url: '/wlapi/tickets/reopen',
    method: 'POST',
    params
  })
}
/**
 * 已解决
 * @param params
 */
export function solveWorkorderAPI (params) {
  return ax({
    url: '/wlapi/tickets/processed',
    method: 'POST',
    params
  })
}
/**
 * 不需解决
 * @param params
 */
export function closeWorkorderAPI (params) {
  return ax({
    url: '/wlapi/tickets/closed',
    method: 'POST',
    params
  })
}
/**
 * 回复工单
 * @param params
 */
export function replyWorkorderAPI (params) {
  return ax({
    url: '/wlapi/tickets/replies',
    method: 'POST',
    params
  })
}
/**
 * 转派工单
 * @param params
 */
export function redeployWorkorderAPI (params) {
  return ax({
    url: '/wlapi/tickets/assignee',
    method: 'POST',
    params
  })
}
/**
 * 工单数量
 * @param params
 */
export function workorderNumberAPI (params) {
  return ax({
    url: '/wlapi/tickets/myTicketsNum',
    method: 'POST',
    params
  })
}
/**
 * 未解决-工单数量
 * @param params
 */
export function workorderUnsolvedNumberAPI (params) {
  return ax({
    url: '/wlapi/tickets/unsolvedTicketsNum',
    method: 'POST',
    params
  })
}
/**
 * 未解决工单
 * @param params
 */
export function getWorkorderUnsolvedListAPI (params) {
  return ax({
    url: '/wlapi/tickets/unsolvedTickets',
    method: 'POST',
    params
  })
}
/**
 * 工单-创建分类
 * @param params
 */
export function addWorkorderSortAPI (params) {
  return ax({
    url: '/wlapi/tickets/creatCategory',
    method: 'POST',
    params
  })
}
/**
 * 工单- 获取分类
 * @param params
 */
export function getWorkorderSortAPI (params) {
  return ax({
    url: '/wlapi/tickets/categoryList',
    method: 'POST',
    params
  })
}
/**
 * 工单- 编辑分类
 * @param params
 */
export function editWorkorderSortAPI (params) {
  return ax({
    url: '/wlapi/tickets/editCategoryName',
    method: 'POST',
    params
  })
}
/**
 * 工单- 删除分类
 * @param params
 */
export function delWorkorderSortAPI (params) {
  return ax({
    url: '/wlapi/tickets/delCategory',
    method: 'POST',
    params
  })
}
/**
 * 工单- 规则列表
 * @param params
 */
export function getWorkorderAutoListAPI (params) {
  return ax({
    url: '/wlapi/tickets/triggersRuleList',
    method: 'POST',
    params
  })
}
/**
 * 工单- 添加规则
 * @param params
 */
export function addWorkorderAutoAPI (params) {
  return ax({
    url: '/wlapi/tickets/addTriggersRule',
    method: 'POST',
    params
  })
}
/**
 * 工单- 编辑规则
 * @param params
 */
export function editWorkorderAutoAPI (params) {
  return ax({
    url: '/wlapi/tickets/editTriggersRule',
    method: 'POST',
    params
  })
}

/**
 * 工单- 删除规则
 * @param params
 */
export function delWorkorderAutoAPI (params) {
  return ax({
    url: '/wlapi/tickets/delTriggersRule',
    method: 'POST',
    params
  })
}
/**
 * 工单- 编辑工单分类
 * @param params
 */
export function editTicketCategoryAPI (params) {
  return ax({
    url: '/wlapi/tickets/editTicketCategory',
    method: 'POST',
    params
  })
}

/**
 * 工单- 筛选工单
 * @param params
 */
export function ticketSearchAPI (params) {
  return ax({
    url: '/wlapi/tickets/ticketSearch',
    method: 'POST',
    data: params
  })
}

/**
 * 工单- 获取自定义筛选列表
 * @param params
 */
export function getCustomSearchAPI (params) {
  return ax({
    url: '/wlapi/tickets/customSearchList',
    method: 'POST',
    params
  })
}
/**
 * 工单- 添加自定义筛选
 * @param params
 */
export function addCustomSearchAPI (params) {
  return ax({
    url: '/wlapi/tickets/addCustomSearch',
    method: 'POST',
    data: params
  })
}

/**
 * 工单- 编辑自定义筛选
 * @param params
 */
export function editCustomSearchAPI (params) {
  return ax({
    url: '/wlapi/tickets/editCustomSearch',
    method: 'POST',
    data: params
  })
}
/**
 * 工单- 删除自定义筛选
 * @param params
 */
export function delCustomSearchAPI (params) {
  return ax({
    url: '/wlapi/tickets/delCustomSearch',
    method: 'POST',
    params
  })
}
/**
 * 工单- 查询用户信息
 * @param params
 */
export function getWorkorderVisitorInfoAPI (params) {
  return ax({
    url: '/wlapi/tickets/visitorInfo',
    method: 'POST',
    params
  })
}
/**
 * 工单- 修改状态
 * @param params
 */
export function editWorkorderPriorityAPI (params) {
  return ax({
    url: '/wlapi/tickets/editPriority',
    method: 'POST',
    params
  })
}
